import { SeatLegroomExtraIcon } from './SeatLegroomExtraIcon';

/**
 * author: Google
 * id F73EE06A-6898-40A7-9B0E-784A4280C075
 * name seat-legroom-extra
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-legroom-extra.svg
 * tags
 */
export const AirlineSeatLegroomExtraIcon = SeatLegroomExtraIcon;
export default AirlineSeatLegroomExtraIcon